import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSaasSettings } from '@/modules/saas/api';

const LIST_AND_REPORT_ROUTES = [
  '/saas/board',
  '/saas/venda',
  '/saas/suporte',
  '/saas/assinantes',
  '/saas/usuarios',
  '/saas/auditoria',
  '/saas/gestao/faturamento',
  '/saas/gestao/dfc',
  '/saas/gestao/dre',
  '/saas/financeiro/categorias',
  '/saas/financeiro/contas',
  '/saas/financeiro/contas-a-pagar',
  '/saas/financeiro/contas-a-receber',
] as const;

function isListOrReportRoute(pathname: string): boolean {
  return LIST_AND_REPORT_ROUTES.some(
    (route) => pathname === route || (route === '/saas/board' && pathname.startsWith(`${route}/`)),
  );
}

export function SaasAdminPolling() {
  const { pathname } = useLocation();
  const queryClient = useQueryClient();
  const settings = useSaasSettings();
  const enabled = isListOrReportRoute(pathname);
  const minutes = settings.data?.adminPollingMinutes ?? 5;

  useEffect(() => {
    if (!enabled || !Number.isInteger(minutes) || minutes < 1) return;

    const timer = window.setInterval(() => {
      void queryClient.refetchQueries({
        type: 'active',
        predicate: (query) => !(query.queryKey[0] === 'saas' && query.queryKey[1] === 'settings'),
      });
    }, minutes * 60_000);

    return () => window.clearInterval(timer);
  }, [enabled, minutes, queryClient]);

  return null;
}
